<template>
  <DashboardAppointments
    :appointments="todaysAppointments"
    title-key="services/concierge_dashboard.today"
    :display-hour="true"
    :display-vehicle-link="true"
    date-hour-label="services/concierge_dashboard.fields.hour"
  />
</template>

<script>
import DashboardAppointments from './DashboardAppointments.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DashboardTodayAppointments',
  props: {
    todaysAppointments: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: { DashboardAppointments }
})
</script>
